import routes from './routes';
import { PtBr, En, Es } from './locales';

const ContratoRastreabilidadeModule = {
    name: 'contrato_rastreabilidade',
    routes,
    locales: {
        'pt-BR': PtBr,
        en: En,
        es: Es
    }
};

export default ContratoRastreabilidadeModule;
